<div class="row justify-content-center py-5">
    <div class="col-12 col-lg-6 d-flex flex-column gap-5">
        <div class="d-flex flex-column align-items-center gap-2">
            <img
                ngSrc="assets/img/sprintpay-horizontal-logo.svg"
                alt="sprintpay logo"
                class="w-25"
                width="237"
                height="56"
            />
            <img
                ngSrc="assets/img/individual-ilustration.svg"
                alt="individual logo"
                class="w-50"
                width="474"
                height="408"
            />
        </div>
        <div class="d-flex flex-column align-items-center gap-3 mt-2">
            <h1 class="mb-0 fs-1">Get started</h1>
            <div class="text-center">
                <h2 class="mb-0">All done! You’re ready to make payment request</h2>
                <p class="mb-0">Redirect to home...</p>
            </div>
            <p class="mb-0">{{ time }}</p>
        </div>
    </div>
</div>
